import React, { useState } from 'react';
import './Login.css';
import { Button, IconButton, CircularProgress } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { message } from 'antd';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LockIcon from '@mui/icons-material/Lock';
import { useAuth } from '../AuthContext';
import Navbar from '../../components/navigationbar/Navbar'
import Loginimg from '../../assets/login-bro.png'
function Login() {
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { login } = useAuth();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleLogin = async () => {
        const { username, password } = formData;
        setLoading(true);

        try {
            const userData = await login(username, password);
            message.success('Login successful');
            if (userData.loginCode === 'GPA10') {
                navigate('/AdminPage');
            } else if (userData.username) {
                navigate('/profile', { state: { username } });
            } else {
                console.error('Username is undefined');
                message.error('Login failed: Username not found');
            }
        } catch (error) {
            console.log(error.message);
            message.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="login">
                <div className="login-container">
                    <div className="login-card">
                        <div className="login-icon">
                            {/* <AccountCircleIcon style={{ fontSize: 70, color: '#77C720' }} /> */}
                            <img src={Loginimg} alt="" />
                        </div>
                        <form>
                            <div className="custom-textfield">
                                <AccountCircleIcon className="icon" />
                                <input
                                    type="text"
                                    name="username"
                                    placeholder="Username"
                                    value={formData.username}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="custom-textfield">
                                <LockIcon className="icon" />
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    name="password"
                                    placeholder="Password"
                                    value={formData.password}
                                    onChange={handleChange}
                                />
                                <IconButton className="visibility-icon" onClick={handleClickShowPassword}>
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </div>
                            <Button
                                onClick={handleLogin}
                                sx={{ marginTop: '10px' }}
                                variant='contained'
                                disabled={loading}
                                fullWidth
                            >
                                {loading ? <CircularProgress size={24} /> : 'Login'}
                            </Button>
                            <div className="login-links">
                                <Link to="/forgot-password">Forgot Password?</Link>
                                <Link to="/register">New Registration</Link>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Login;
